import React, { Component, Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Redirect, Switch, Link } from "react-router-dom";
import environment from "environment";
import Analytics from "react-router-ga";

import "./css/global.less";
import "./css/layout.less";
import "./css/layoutHeader.less";

import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import HomePage from "./Pages/Home/HomePage";
import AboutPage from "./Pages/About/AboutPage";
import SearchPage from "./Pages/Search/SearchPage";
import SubmitPage from "./Pages/Submit/SubmitPage";
import RecentPage from "./Pages/Recent/RecentPage";
import ThisDayPage from "./Pages/ThisDay/ThisDayPage";
import ProfilePage from "./Pages/Profile/ProfilePage";
import DetailPage from "./Pages/Detail/DetailPage";
import FileUnderPage from "./Pages/FileUnder/FileUnderPage";
import ScrollToTop from "./Components/Global/ScrollToTop";
import BackToTop from "./Components/Global/BackToTop";
import HeaderMenu from "./Components/Global/HeaderMenu";
import HeaderLogin from "./Components/Global/HeaderLogin";
import FooterNav from "./Components/Global/FooterNav";

import DevBanner from "./Components/Global/DevBanner";

import { useUser } from "~/Context/userContext";

const EditPage = lazy(() => import("./Pages/Detail/EditPage"));

const NoMatchPage = () => {
  return (
    <h3>
      Bummer. Page Not Found - <Link to="/">Back to Home</Link>
    </h3>
  );
};

const App = () => {
  const { state: userState } = useUser();
  const year = new Date().getFullYear();
  return (
    <div className="app-otd" id="top">
      <DevBanner />
      <Suspense fallback={<div>Loading...</div>}>
        <Router basename="/oftheday">

          <Container className="app-container" fluid={false}>
            <Row>
              <Col xs={12}>
                <div className="middle-wrapper">
                  <div className="main-section">
                    <div className="masthead">
                      {userState && userState.loggedin && userState.isChim && (
                        <Link to={`/submit`}>
                          <div className="burst" />
                        </Link>
                      )}

                      <Link to="/">
                        <h1>___ of the Day</h1>
                      </Link>
                    </div>

                    <div className="row middleNav">
                      <div className="col-xs-12 col-sm-7">
                        <HeaderMenu />
                      </div>

                      <div className="col-xs-12 col-sm-5 headerWelcome">
                        <HeaderLogin />
                      </div>
                    </div>

                    <div className="contentPadding">
                      <Analytics basename="/oftheday" id="UA-95892-1" debug={environment.isDevelopment}>
                        <ScrollToTop />

                        <Switch>
                          <Route exact path="/about" name="about" component={AboutPage} />
                          <Route exact path="/search" name="search" component={SearchPage} />
                          <Route exact path="/recent" name="recent" component={RecentPage} />
                          <Route exact path="/thisday" name="thisday" component={ThisDayPage} />
                          <PrivateRoute exact path="/submit" name="submit">
                            <SubmitPage />
                          </PrivateRoute>
                          <Route exact path="/:slug" name="detail" component={DetailPage} />
                          <PrivateRoute exact path="/edit/:id/:slug" name="detailEdit">
                            <EditPage />
                          </PrivateRoute>
                          {/* <Route exact path="/edit/:slug" name="detailEdit" component={EditPage} /> */}
                          <Route exact path="/tag/:slug" name="fileunder" component={FileUnderPage} />
                          <Route exact path="/profile/:slug" name="profile" component={ProfilePage} />
                          <Route exact path="/" name="home" component={HomePage} />

                          <Route path="*">
                            <NoMatchPage />
                          </Route>
                        </Switch>
                      </Analytics>

                      {/* <Route render={() => <Redirect to="/" />} /> */}
                      <FooterNav />
                    </div>
                  </div>
                </div>

                <div className="col-md-12" id="bottom-wrapper"></div>

                <footer className="footer">
                  <div className="text-center footer-inner">
                    &copy; {year}
                    {" "}
                    <a href="/" target="_blank">
                      Dream Chimney
                    </a>{" "}
                    Inc.
                  </div>
                </footer>
              </Col>
            </Row>
          </Container>
        </Router>
      </Suspense>
      <BackToTop />
      {/* <SiteFooter /> */}
    </div>
  );
};

function PrivateRoute({ children, ...rest }) {
  const { state: userState } = useUser();
  // have to cloneElement to pass match to children element, the page component
  return (
    <Route
      {...rest}
      render={({ location, match }) => {
        const newChild = React.cloneElement(children, {
          match,
        });
        if (!userState.loaded) {
          return null;
        }
        return userState && userState.loggedin && userState.isChim ? (
          newChild
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
}

export default App;
